export const faqs = [
    {
        id: 1,
        question: "What does MITSI specialized in?",
        answer:
            "We transform healthcare with advanced diagnostics, new wound treatments, and on-site labs. Our mission is to improve patient outcomes, cut costs, and increase efficiency. MITSI offers complete solutions for today's medical practices.",
    },

    {
        id: 2,
        question: "How does MITSI help healthcare providers?",
        answer:
            "MITSI offers innovative solutions. They include neurofeedback, advanced wound care with placental grafts, and in-house diagnostics labs. We provide training, equipment, and billing help. This helps practices improve patient care and boost revenue.",
    },
    {
        id: 3,
        question: "Do MITSI services require upfront costs?",
        answer:
            "No, MITSI offers solutions with no upfront costs. Our pricing models help practices start without big costs. This makes healthcare advances more accessible.",
    },
    {
        id: 4,
        question: "Are MITSI services covered by insurance?",
        answer:
            "Medicare, Medicaid, and top insurers cover our neurofeedback and wound care services. We simplify billing to maximize your reimbursements. Our team manages insurance issues, allowing you to focus on healing.",
    },
    {
        id: 5,
        question: "How do I get started with MITSI?",
        answer:
            "Visit our website to get started. Our experts will evaluate your needs and suggest personalized solutions. We'll assist you from setup to full implementation and staff training.",
    },
];
